<div *ngFor="let profile of profileResults.Result" class="results-row mct-flex mct-row">
  <div class="mct-basis-10">
    {{ profile.ProfileId }}
  </div>
  <div class="mct-basis-45">
    <wl-profile-type-icon [isMember]="profile.Member" [isOrg]="profile.OrgInd"
      [styleOverrides]="{ 'max-height': '34px', 'max-width': '34px' }"></wl-profile-type-icon>
    {{ profile.ReportName }}
  </div>
  <div class="mct-flex mct-col mct-justify-around mct-items-stretch mct-basis-35">
    <div [hidden]="!profile.MainRelatedProfileName">
      <strong>{{ profile.MainRelatedProfileName }}</strong>
    </div>
    <div [hidden]="!profile.Address1">{{ profile.Address1 }}</div>
    <div [hidden]="!profile.Address2">{{ profile.Address2 }}</div>
    <div [hidden]="!profile.City && !profile.State && !profile.Zip">
      {{ profile.City ? profile.City + ', ' : '' }}
      {{ profile.State }}
      {{ profile.Zip }}
    </div>
  </div>
  <div class="mct-flex mct-justify-end mct-items-stretch mct-basis-10 mct-self-start">
    <button pButton type="button" data-cy="buttonSelectProfileResultsGrid" class="atlas-btn atlas-btn-primary"
      [disabled]="disableSelectForProfileIds.includes(profile.ProfileId)" (click)="selectProfile(profile)">
      {{ selectButtonText | translate | titlecase }}
    </button>
  </div>
</div>